<div class="description">
    @if (title) {
        <h3
            class="description__title"
        >
            {{ title }}
        </h3>
    }
    @if (safeHtmlDescription) {
        <div
            class="description__content"
            [innerHtml]="safeHtmlDescription"
        ></div>
    }
    <ng-content />
</div>
